const newCustomer = {
  snackbar: "Su actualización esta completada",
  name: "Tipo de Sello",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Tipo de Sello",
  formTitle: "Nuevo Tipo de Sello",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newCustomer;
